module.exports = __webpack_public_path__ + "static/media/bndvSites.9f921718.png";